const BINARY_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export interface FormatBytesOptions {
  /** Returned when bytes is 0/undefined/null. Default: `'0 B'`. */
  placeholder?: string;
  /**
   * Decimal places. `'smart'` (default) shows 1 decimal when the scaled
   * value is < 10 and rounds to integer otherwise — matches the
   * Disk Usage Analyzer behaviour.
   */
  decimals?: number | 'smart';
}

/** Formats a byte count using binary (1024-based) units. */
export function formatBytes(bytes: number | undefined | null, opts: FormatBytesOptions = {}): string {
  const { placeholder = '0 B', decimals = 'smart' } = opts;
  if (!bytes || bytes <= 0) return placeholder;

  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), BINARY_UNITS.length - 1);
  const value = bytes / Math.pow(1024, i);
  const formatted = decimals === 'smart'
    ? (value < 10 ? value.toFixed(1) : Math.round(value).toString())
    : value.toFixed(decimals);

  return `${formatted} ${BINARY_UNITS[i]}`;
}

/** Local "YYYY-MM-DD HH:MM:SS", used to seed auto-generated entity names. */
export function formatAutoNameTimestamp(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  const d = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const t = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  return `${d} ${t}`;
}
